import React from 'react';
import Checkbox, { Props as CheckboxProps } from './CheckBox';
import { Controller, RegisterOptions, UseFormReturn } from 'react-hook-form';

type Props = {
    form: UseFormReturn<any>;    
    name: string;
    rules?: Exclude<RegisterOptions, 'valueAsNumber' | 'valueAsDate' | 'setValueAs'>;
} & CheckboxProps;

const CheckBoxController = ({ form, name, label, rules, ...props }: Props) => {
    
    return (
        <Controller
            render={({ field }) => {
                return (
                    <Checkbox
                        {...props}                        
                        label={label}
                        {...field}
                        onChange={e => {
                            field.onChange(e.target.checked);                          
                        }}
                        checked={field.value ? true : false}
                    />
                );
            }}
            control={form.control}            
            name={name}
            defaultValue={form.getValues(name) || null}
            rules={rules}
        />
    );
};

export default CheckBoxController;
